/* WebsiteHQ-only product card polish.
 *
 * raftor_webhq owns the variant swatch engine globally; WebsiteHQ owns the
 * storefront presentation polish after those swatches arrive.
 */
(function () {
  "use strict";

  var PRODUCT_SCOPE = ".rfhq-item-grid, .rfhq-item-carousel, .rfhq-product-card, #product-listing, .item-card-group-section";
  var PRODUCT_CARD_SELECTOR = ".item-card, .card";

  function isColourRow(row) {
    var attribute = (row && row.getAttribute("data-attribute")) || "";
    return /^colou?r$/i.test(attribute.trim());
  }

  function directChildFor(cardBody, node) {
    var target = node;
    while (target && target.parentNode && target.parentNode !== cardBody) {
      target = target.parentNode;
    }
    return target && target.parentNode === cardBody ? target : node;
  }

  function insertBeforeProductTitle(cardBody, row) {
    var title = cardBody.querySelector(".product-title[itemprop='name'], .product-title");
    var target = title ? directChildFor(cardBody, title) : cardBody.firstChild;

    // insertBefore always fires a childList mutation, even when it doesn't
    // change the row's position - and this module's own MutationObserver
    // watches document.body for exactly that, so a non-idempotent call here
    // re-triggers itself forever (infinite reflow loop, tab hangs, nothing
    // in the card - including the colour pills - stays clickable).
    if (!target || row === target || row.nextSibling === target) return;

    cardBody.insertBefore(row, target);
  }

  function getProductCardSurface(node) {
    if (!node || !node.closest) return null;
    var surface = node.matches && node.matches(PRODUCT_CARD_SELECTOR)
      ? node
      : node.closest(PRODUCT_CARD_SELECTOR);
    if (!surface || !surface.closest(PRODUCT_SCOPE)) return null;
    if (!surface.querySelector(".card-body")) return null;
    return surface;
  }

  function polishCard(card) {
    if (!card || !card.querySelector) return;
    if (!card.closest(PRODUCT_SCOPE)) return;

    var cardBody = card.querySelector(".card-body");
    if (!cardBody) return;

    card.classList.add("rfhq-product-card-surface");

    Array.prototype.forEach.call(card.querySelectorAll(".variant-attr-row"), function (row) {
      if (!isColourRow(row)) return;
      if (row.parentNode === cardBody) {
        insertBeforeProductTitle(cardBody, row);
        return;
      }
      cardBody.insertBefore(row, cardBody.firstChild);
      insertBeforeProductTitle(cardBody, row);
    });
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    polishCard(getProductCardSurface(root));
    Array.prototype.forEach.call(root.querySelectorAll(PRODUCT_CARD_SELECTOR), function (card) {
      polishCard(getProductCardSurface(card));
    });
  }

  frappe.ready(function () {
    scan(document);

    if (window.rfhqDom && window.rfhqDom.onAdded) {
      window.rfhqDom.onAdded(function (roots) {
        roots.forEach(scan);
      });
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, scan);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
}());
